export const departurePickerName = 'lt-departure-picker';
export const departurePlaceholder = 'Город вылета';
export const INPUT_CONTROL_HEIGHT = '64px';
